import React from 'react';
import PackageListingPage from '../PackageListingPage/PackageListingPage';

function Dashboard(){
    return(
       <>
        <PackageListingPage />
       </>
    )
}

export default Dashboard